import axiosInstance from '../utils/AxiosConfig';

export const getReferences = async (locationId, options = {}) => {
  const response = await axiosInstance.get('/supplies/all_references', {
    params: {
      locationId: locationId
    },
    // Esta consulta se usa como dato auxiliar en algunos formularios. Quien la
    // invoque puede manejar un 403 localmente sin navegar a la página global.
    skipGlobalErrorRedirect: options.skipGlobalErrorRedirect === true
  });
  return response.data.data;
};

export const getSupplies = async (locationId, page = 1, pageSize = 10, searchTerm = '', options = {}) => {
  const params = new URLSearchParams({
    locationId: locationId.toString(),
    page: page.toString(),
    pageSize: pageSize.toString()
  });
  
  if (searchTerm && typeof searchTerm === 'string' && searchTerm.trim()) {
    params.append('search', searchTerm.trim());
  }
  if (options.sortField) params.append('sortField', options.sortField);
  if (options.sortDirection) params.append('sortDirection', options.sortDirection);
  if (options.filterField) params.append('filterField', options.filterField);
  if (options.filterOperator) params.append('filterOperator', options.filterOperator);
  if (options.filterValue !== undefined && options.filterValue !== null && options.filterValue !== '') {
    params.append('filterValue', options.filterValue.toString());
  }
  
  const response = await axiosInstance.get(`/supplies?${params}`);
  return response.data.data;
};

export const createSupply = async (supply, locationId) => {
  const response = await axiosInstance.post(`/supplies`, {
    location_id: locationId,
    name: supply.name,
    iva: supply.iva,
    unit: parseInt(supply.unit),
    conversion_factor: parseFloat(supply.conversionFactor),
    primary_supplier: parseInt(supply.primarySupplier),
    secondary_supplier: supply.secondarySupplier ? parseInt(supply.secondarySupplier) : null,
    notes: supply.notes,
    stock: 0,
    minimum_stock: supply.countsStock ? parseFloat(supply.minimumStock || 0) : 0,
    suggested_stock: supply.countsStock ? parseFloat(supply.suggestedStock || 0) : 0,
    alternative: supply.alternative,
    category: parseInt(supply.category),
    sub_category: parseInt(supply.subCategory),
    presentation_quantity: parseFloat(supply.presentationQuantity),
    uses_lot: !!supply.usesLot,
    counts_stock: !!supply.countsStock,
  });
  return response.data.data;
};

export const updateSupply = async (supply, locationId) => {
  const response = await axiosInstance.put(`/supplies/${supply.id}`, {
    location_id: locationId,
    name: supply.name,
    iva: supply.iva,
    unit: parseInt(supply.unit),
    cost: parseFloat(supply.price),
    ...(supply.costCurrency ? { cost_currency: supply.costCurrency } : {}),
    conversion_factor: parseFloat(supply.conversionFactor),
    primary_supplier: parseInt(supply.primarySupplier),
    secondary_supplier: supply.secondarySupplier ? parseInt(supply.secondarySupplier) : null,
    stock: supply.countsStock ? parseFloat(supply.stock || 0) : 0,
    minimum_stock: supply.countsStock ? parseFloat(supply.minimumStock || 0) : 0,
    suggested_stock: supply.countsStock ? parseFloat(supply.suggestedStock || 0) : 0,
    notes: supply.notes,
    alternative: supply.alternative,
    category: parseInt(supply.category),
    sub_category: parseInt(supply.subCategory),
    presentation_quantity: parseFloat(supply.presentationQuantity),
    uses_lot: !!supply.usesLot,
    counts_stock: !!supply.countsStock,
  });
  return response.data.data;
};

export const updateStock = async (id, request) => {
  const response = await axiosInstance.put(`/supplies/stock/${id}`, request);

  console.log(response)
  
  return response.data.data;
};

export const deleteSupply = async (id) => {
  await axiosInstance.delete(`/supplies/${id}`);
};
